import { CnMessage } from '@/components/cn-message';

export default CnMessage;
